import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Highlight {
    id: number;
    book_id: number;
    selection: string;
    cfi: string;
    page_no: number;
    href: string;
    properties: {
        colour: string;
        underline: boolean;
    };
    is_active: boolean;
    created_at: string;
    updated_at: string;
}

interface HighlightsState {
    highlights: Highlight[];
}

const initialState: HighlightsState = {
    highlights: [],
};

const highlightsSlice = createSlice({
    name: 'highlights',
    initialState,
    reducers: {
        setHighlights: (state, action: PayloadAction<Highlight[]>) => {
            state.highlights = action.payload;
        },
        appendHighlight: (state, action: PayloadAction<Highlight>) => {
            state.highlights.push(action.payload);
        },
        removeHighlight: (state, action: PayloadAction<number>) => {
            state.highlights = state.highlights.filter(
                (highlight) => highlight.id !== action.payload
            );
        },
    },
});

export const { setHighlights, appendHighlight, removeHighlight } =
    highlightsSlice.actions;

export default highlightsSlice.reducer;
